/*global site_info */
import PDFJSExpress from '@pdftron/pdfjs-express-viewer';
import {PDFController} from './pdf-controller';

export default {
    container: null,
    pdf: null,
    ran: false,

    init: function (PDFUrl, $container) {
        this.container = $container;
        if (this.container.find('iframe').length) return;
        this.pdf = PDFUrl;
        $(document).on('scroll', () => this.setup());
        setTimeout(() => this.setup(), 5000);
        this.bindEvents();
    },

    setup() {
        $(document).off('scroll', this.setup);
        if (this.ran) return;
        PDFJSExpress({
            path: '/wp-content/themes/skybox-security/public/js/pdfjsexpress',
            licenseKey: site_info.PDFJSExpress_key,
            initialDoc: this.pdf,
            disabledElements: [
                'header',
                'contextMenuPopup',
            ],
        }, this.container[0])
            .then(instance => {
                new PDFController(instance);
            });
        this.ran = true;
    },

    bindEvents: function () {
        $(window).on('modal-open', () => this.setup());
    },

};
